// removed by extract-text-webpack-plugin
module.exports = {"mapBanner":"map-banner-module__mapBanner___1sG5K","mapBannerHeading":"map-banner-module__mapBannerHeading___3rFQI","mapBannerDataRow":"map-banner-module__mapBannerDataRow___QdEAe","mapBannerDataBlockWrapper":"map-banner-module__mapBannerDataBlockWrapper___1GkYa","mapBannerDataBlockContent":"map-banner-module__mapBannerDataBlockContent___bCs6Y","mapBannerDataNumber":"map-banner-module__mapBannerDataNumber___mPYiz","mapBannerLegend":"map-banner-module__mapBannerLegend___PFyd9","closeButton":"map-banner-module__closeButton___Oshie","externalLink":"map-banner-module__externalLink___bzkqK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/council-map-container/map-banner.module.scss
// module id = 565
// module chunks = 0 1